import {
    DIC
} from '@/const/dic'
import {baseUrl} from '@/config/env';



export const pointsDetailTableOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: true,
    menuWidth: '300',
    labelWidth: '120',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
        label: "奖惩类型",
        prop: "type",
        search: true,
        type: 'select',
        dicData: DIC.POINTS_RULE_TYPE,
        rules: [{
            required: true,
            trigger: "blur",
            message: "请选择奖惩类型"
        }]
        },{
            label: "员工姓名",
            prop: "stuffName",
            search: true,
            type: 'input'
        },
        {
            label: "对应积分",
            prop: "points",
            placeholder: "请输入对应积分",
            type: 'number'
        },
        {
            label: "提交人姓名",
            prop: "submitStuffName",
            type: 'input'
        },
        {
            label: "提交时间",
            prop: "submitTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss"
        },
        {
            label: "审批人姓名",
            prop: "approveStuffName",
            type: 'input'
        },
        {
            label: "审批时间",
            prop: "approveTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss"
        },
        {
            label: "状态",
            prop: "status",
            type: "radio",
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.POINTS_DETAIL_STATUS
        },
        {
            label: "描述",
            prop: "pointsDescribe",
            type: "textarea",
            span : 24,
            max: 255
        },
        // {
        //     label: "创建时间",
        //     prop: "createTime",
        //     type: "datetime",
        //     sortable: true,
        //     format: "yyyy-MM-dd HH:mm:ss",
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "创建人",
        //     prop: "createBy",
        //     type: "input",
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "状态",
        //     prop: "status",
        //     type: "radio",
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     dicData: DIC.STATUS_STATE_MODEL
        // },
        // {
        //     label: "更新时间",
        //     prop: "updateTime",
        //     type: "datetime",
        //     format: "yyyy-MM-dd HH:mm:ss",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "更新人",
        //     prop: "updateBy",
        //     type: "input",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "是否删除",
        //     prop: "deleteFlag",
        //     type: "radio",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     dicData: DIC.DELETE_FLAG
        // },
        // {
        //     label: "备注",
        //     prop: "remarks",
        //     type: "textarea",
        //     span: 24,
        //     hide: true,
        //     max: 255
        // }


    ]
};